(function ($) {
    $.fn.toggleVisible = function () {
        return $(this).each(function () {
            var $this = $(this);
            var $target = $($this.attr('data-visible'));
            var tagName = this.tagName.toLowerCase();

            if (!$target.exists()) return;

            if (tagName === 'input' && $this.attr('type') === 'checkbox') {
                toggleTargetForCheckbox($this, $target);
                $this.on('change', function () {
                    toggleTargetForCheckbox($this, $target);
                });
            } else {
                $this.on('click', function () {
                    $target.toggle();
                });
            }
        });
    };

    function toggleTargetForCheckbox($this, $target) {
        if ($this.is(':checked')) {
            $target.css('display', 'block');
        } else {
            $target.css('display', 'none');
        }
    }
})(jQuery);